module.exports = __webpack_public_path__ + "img/bg-icons.5e630043.png";